// extracted by mini-css-extract-plugin
module.exports = {"starsWrapper":"dYIsLTWY9yCePNivXkYv3g==","reviewLocation":"_2mRld2HCLLwci0dujYhYkA==","verifiedImg":"kipxAKTZupwl8N9vVK0OJg=="};